(function () {
  "use strict";

  var app = document.getElementById("rx-upload-app");
  if (!app) return;

  var API_BASE = "https://felix-gray-backend-171417293160.europe-west1.run.app";
  var PD_TOOL_URL = app.dataset.pdToolUrl || "";

  var loadingEl = document.getElementById("rx-loading");
  var errorEl = document.getElementById("rx-error");
  var errorMsgEl = document.getElementById("rx-error-message");
  var formsWrapper = document.getElementById("rx-forms-wrapper");
  var formsContainer = document.getElementById("rx-forms");
  var orderHeader = document.getElementById("rx-order-header");

  // ─── Parse & validate query params ───────────────────────────────────────────

  var params = new URLSearchParams(window.location.search);
  var orderId = params.get("orderId");
  var customerId = params.get("customerId");

  if (!orderId || !customerId) {
    showError(
      "Missing order information. Please use the link provided in your prescription email.",
    );
    return;
  }

  // ─── Fetch order details ──────────────────────────────────────────────────────

  fetch(API_BASE + "/order-details", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderId: orderId, customerId: customerId }),
  })
    .then(function (res) {
      if (!res.ok) throw new Error("HTTP " + res.status);
      return res.json();
    })
    .then(function (order) {
      renderPage(order);
    })
    .catch(function () {
      showError(
        "Unable to load your order details. Please try again or contact support.",
      );
    });

  // ─── Page rendering ───────────────────────────────────────────────────────────

  function renderPage(order) {
    loadingEl.classList.add("rx-hidden");

    orderHeader.innerHTML =
      '<h1 class="h2">Upload Your Prescription</h1>' +
      '<p class="text-subdued">Order ' +
      escHtml(order.orderName) +
      " &mdash; " +
      escHtml(order.customer.firstName) +
      " " +
      escHtml(order.customer.lastName) +
      "</p>";

    var items = order.bundles || order.lineItems;
    var rxItems = getRxFrameItems(items);

    if (!rxItems.length) {
      showError(
        "No prescription frames were found for this order. If this seems wrong, please contact support.",
      );
      return;
    }

    formsContainer.appendChild(buildMasterForm(rxItems, order));
    formsWrapper.classList.remove("rx-hidden");
  }

  // ─── Single master form containing all frames ─────────────────────────────────

  function buildMasterForm(items, order) {
    var form = document.createElement("form");
    form.id = "rx-master-form";
    form.className = "form v-stack gap-8";

    items.forEach(function (frameItem, index) {
      form.appendChild(buildFrameSection(frameItem, index, items, order));
    });

    // Overall error banner
    var overallError = document.createElement("div");
    overallError.id = "rx-overall-error";
    overallError.className = "banner banner--error rx-hidden";
    overallError.innerHTML = "<p></p>";
    form.appendChild(overallError);

    // Single submit button for all frames
    var submitBtn = document.createElement("button");
    submitBtn.type = "submit";
    submitBtn.id = "rx-submit-btn";
    submitBtn.className = "button";
    submitBtn.textContent =
      items.length > 1 ? "Submit All Prescriptions" : "Submit Prescription";
    form.appendChild(submitBtn);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      submitAll(form, items, order, submitBtn);
    });

    return form;
  }

  // ─── Build the section for one frame ─────────────────────────────────────────

  function buildFrameSection(frameItem, index, allItems, order) {
    var item = frameItem.item;
    var orderFrameIndex = frameItem.orderFrameIndex;

    var section = document.createElement("div");
    section.className = "rx-item v-stack gap-6";
    section.dataset.index = index;

    // Product thumbnail + name
    var header = document.createElement("div");
    header.className = "rx-item__header h-stack gap-4";
    header.innerHTML =
      (item.image
        ? '<img src="' +
          escAttr(item.image) +
          '" alt="' +
          escAttr(item.imageAlt || "") +
          '" class="rx-item__image" width="72" height="72" loading="lazy">'
        : "") +
      '<div class="v-stack gap-1">' +
      '<p class="h4">' +
      escHtml(item.bundleName || item.name) +
      "</p>" +
      (item.variantTitle
        ? '<p class="text-subdued">' + escHtml(item.variantTitle) + "</p>"
        : "") +
      (item.quantity > 1
        ? '<p class="text-subdued subheading">Qty: ' +
          escHtml(String(item.quantity)) +
          "</p>"
        : "") +
      "</div>";
    section.appendChild(header);

    // FG Order Number — read-only, suffixed per frame
    var orderRow = document.createElement("div");
    orderRow.className = "fieldset-row";
    orderRow.appendChild(
      buildInput({
        index: index,
        name: "orderNumber",
        label: "FG Order Number",
        value: order.orderName + "-" + (orderFrameIndex + 1),
        readonly: true,
      }),
    );
    section.appendChild(orderRow);

    // "Same person as" toggle — shown for every frame after the first
    if (index > 0) {
      section.appendChild(buildSameAsControl(index, allItems));
    }

    // Personal details group (hidden when "same as" is active)
    var personalGroup = document.createElement("div");
    personalGroup.id = "rx-personal-" + index;
    personalGroup.className = "rx-personal-group v-stack gap-6";

    var nameRow = document.createElement("div");
    nameRow.className = "fieldset-row";
    nameRow.appendChild(
      buildInput({
        index: index,
        name: "firstName",
        label: "First Name",
        value: "Thomas",
        required: true,
        autocomplete: "given-name",
      }),
    );
    nameRow.appendChild(
      buildInput({
        index: index,
        name: "lastName",
        label: "Last Name",
        value: "MacLean",
        required: true,
        autocomplete: "family-name",
      }),
    );
    personalGroup.appendChild(nameRow);

    var emailRow = document.createElement("div");
    emailRow.className = "fieldset-row";
    emailRow.appendChild(
      buildInput({
        index: index,
        name: "email",
        type: "email",
        label: "Email Address",
        value: "hello@thomasmaclean.be",
        required: true,
        autocomplete: "email",
      }),
    );
    personalGroup.appendChild(emailRow);

    var pdRow = document.createElement("div");
    pdRow.className = "fieldset-row";
    var pdControl = buildInput({
      index: index,
      name: "pd",
      label: "PD Measurement",
      placeholder: "e.g. 63 or 31.5 / 32",
      required: true,
    });
    var pdHint = document.createElement("p");
    pdHint.className = "rx-field-hint text-subdued";
    pdHint.innerHTML =
      "Don't know your PD? " +
      '<a href="' +
      escAttr(PD_TOOL_URL || "/pages/pd-measurement") +
      '" target="_blank" rel="noopener noreferrer" class="link">' +
      "Measure it with our free tool</a>.";
    pdControl.appendChild(pdHint);
    pdRow.appendChild(pdControl);
    personalGroup.appendChild(pdRow);

    section.appendChild(personalGroup);

    // Prescription file upload — hidden when "same as" is active
    var fileRow = document.createElement("div");
    fileRow.id = "rx-file-row-" + index;
    fileRow.className = "fieldset-row";
    fileRow.appendChild(
      buildFileInput({
        index: index,
        name: "prescriptionFile",
        required: true,
      }),
    );
    section.appendChild(fileRow);

    // PHI consent — always shown
    var consentRow = document.createElement("div");
    consentRow.className = "fieldset-row";
    consentRow.appendChild(
      buildCheckbox({
        index: index,
        name: "phiConsent",
        required: true,
        label:
          "I consent to provide Protected Health Information (PHI) for the purpose of processing my prescription order.",
      }),
    );
    section.appendChild(consentRow);

    // Per-frame status banners
    var frameError = document.createElement("div");
    frameError.id = "rx-frame-error-" + index;
    frameError.className = "banner banner--error rx-hidden";
    frameError.innerHTML = "<p></p>";
    section.appendChild(frameError);

    var frameSuccess = document.createElement("div");
    frameSuccess.id = "rx-frame-success-" + index;
    frameSuccess.className = "banner banner--success rx-hidden";
    frameSuccess.innerHTML =
      "<p>Prescription submitted successfully. We'll be in touch shortly.</p>";
    section.appendChild(frameSuccess);

    // Divider between frames
    var hr = document.createElement("hr");
    hr.className = "rx-divider";
    section.appendChild(hr);

    return section;
  }

  // ─── "Same person as" checkbox + frame selector ───────────────────────────────

  function buildSameAsControl(index, allItems) {
    var wrapper = document.createElement("div");
    wrapper.className = "rx-same-as-control v-stack gap-3";

    // Checkbox row
    var checkRow = document.createElement("div");
    checkRow.className = "checkbox-control";

    var checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = "rx-same-as-check-" + index;
    checkbox.className = "checkbox";
    checkRow.appendChild(checkbox);

    var checkLabel = document.createElement("label");
    checkLabel.htmlFor = "rx-same-as-check-" + index;
    checkLabel.textContent =
      "This prescription is for the same person as another frame";
    checkRow.appendChild(checkLabel);

    wrapper.appendChild(checkRow);

    // Frame selector — hidden until checkbox is ticked
    var selectRow = document.createElement("div");
    selectRow.id = "rx-same-as-select-row-" + index;
    selectRow.className = "rx-same-as-select-row rx-hidden";

    var selectLabel = document.createElement("label");
    selectLabel.htmlFor = "rx-same-as-select-" + index;
    selectLabel.className = "rx-same-as-select-label text-subdued";
    selectLabel.textContent = "Copy details from:";
    selectRow.appendChild(selectLabel);

    var select = document.createElement("select");
    select.id = "rx-same-as-select-" + index;
    select.className = "select";

    for (var i = 0; i < allItems.length; i++) {
      if (i === index) continue;
      var option = document.createElement("option");
      option.value = i;
      var optionFrame = allItems[i];
      option.textContent =
        "Frame " +
        (optionFrame.orderFrameIndex + 1) +
        " \u2014 " +
        (optionFrame.item.bundleName || optionFrame.item.name);
      select.appendChild(option);
    }

    selectRow.appendChild(select);
    wrapper.appendChild(selectRow);

    // Toggle personal fields + file row visibility and required state
    checkbox.addEventListener("change", function () {
      var personalGroup = document.getElementById("rx-personal-" + index);
      var fileRowEl = document.getElementById("rx-file-row-" + index);
      var fileInput = document.getElementById(
        "rx-file-" + index + "-prescriptionFile",
      );
      var isChecked = checkbox.checked;
      selectRow.classList.toggle("rx-hidden", !isChecked);
      personalGroup.classList.toggle("rx-hidden", isChecked);
      setPersonalRequired(personalGroup, !isChecked);
      fileRowEl.classList.toggle("rx-hidden", isChecked);
      if (fileInput) fileInput.required = !isChecked;
    });

    return wrapper;
  }

  // ─── Form submission ──────────────────────────────────────────────────────────

  function submitAll(form, items, order, btn) {
    // Clear all banners
    document.getElementById("rx-overall-error").classList.add("rx-hidden");
    items.forEach(function (item, i) {
      document.getElementById("rx-frame-error-" + i).classList.add("rx-hidden");
    });

    // Validate all frames before making any API calls
    for (var i = 0; i < items.length; i++) {
      var consentEl = document.getElementById(
        "rx-checkbox-" + i + "-phiConsent",
      );
      if (consentEl && !consentEl.checked) {
        showFrameError(
          document.getElementById("rx-frame-error-" + i),
          "You must consent to provide Protected Health Information (PHI) to submit.",
        );
        return;
      }

      var sameAsCheck = document.getElementById("rx-same-as-check-" + i);
      var usingSourceFile = sameAsCheck && sameAsCheck.checked;
      if (!usingSourceFile) {
        var fileEl = document.getElementById(
          "rx-file-" + i + "-prescriptionFile",
        );
        if (
          fileEl &&
          fileEl.files[0] &&
          fileEl.files[0].size > 10 * 1024 * 1024
        ) {
          showFrameError(
            document.getElementById("rx-frame-error-" + i),
            "Your file is too large. Please upload a file under 10 MB.",
          );
          return;
        }
      }
    }

    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    btn.textContent = "Uploading\u2026";

    // Submit each frame as a separate API call
    var calls = items.map(function (frameItem, index) {
      return fetch(API_BASE + "/upload-file", {
        method: "POST",
        // NOTE: Do not set Content-Type — browser sets it with the correct multipart boundary.
        body: buildFrameFormData(frameItem, index, order),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (body) {
              throw new Error(
                body.message || "Submission failed. Please try again.",
              );
            });
          }
          return res.json();
        })
        .then(function () {
          document
            .getElementById("rx-frame-success-" + index)
            .classList.remove("rx-hidden");
        })
        .catch(function (err) {
          showFrameError(
            document.getElementById("rx-frame-error-" + index),
            err.message || "Submission failed. Please try again.",
          );
          throw err;
        });
    });

    Promise.all(calls)
      .then(function () {
        // Disable the entire form on full success
        Array.prototype.forEach.call(
          form.querySelectorAll("input, textarea, select, button"),
          function (el) {
            el.disabled = true;
          },
        );
        btn.removeAttribute("aria-busy");
        btn.textContent =
          items.length > 1
            ? "All Prescriptions Submitted"
            : "Prescription Submitted";
      })
      .catch(function () {
        btn.removeAttribute("aria-busy");
        btn.disabled = false;
        btn.textContent =
          items.length > 1 ? "Submit All Prescriptions" : "Submit Prescription";
      });
  }

  // ─── Build FormData for one frame ────────────────────────────────────────────

  function buildFrameFormData(frameItem, index, order) {
    var item = frameItem.item;
    var orderFrameIndex = frameItem.orderFrameIndex;

    // Follow the "same as" chain to find the frame with actual personal details
    var sourceIndex = resolveSourceIndex(index);

    var fd = new FormData();
    fd.append("orderId", order.orderId);
    fd.append("orderName", order.orderName + "-" + (orderFrameIndex + 1));
    fd.append("orderNumber", order.orderName + "-" + (orderFrameIndex + 1));
    fd.append("customerId", customerId);
    fd.append("name", item.bundleName || item.name);
    fd.append("itemVariant", item.variantTitle || "");
    fd.append("sku", getItemSku(item));

    ["firstName", "lastName", "email", "pd"].forEach(function (name) {
      var el = document.getElementById("rx-input-" + sourceIndex + "-" + name);
      if (el) fd.append(name, el.value);
    });

    var consentEl = document.getElementById(
      "rx-checkbox-" + index + "-phiConsent",
    );
    if (consentEl) fd.append("phiConsent", consentEl.checked ? "1" : "");

    // Use source frame's file if this frame delegates to another
    var fileEl = document.getElementById(
      "rx-file-" + sourceIndex + "-prescriptionFile",
    );
    if (fileEl && fileEl.files[0])
      fd.append("prescriptionFile", fileEl.files[0]);

    return fd;
  }

  function getRxFrameItems(items) {
    var frameItems = extractFrameItems(items);

    // Preferred: direct RX signal on frame/bundle objects.
    var directRxFrames = frameItems.filter(function (frameItem) {
      return isRxFrameItem(frameItem.item);
    });
    if (directRxFrames.length) return directRxFrames;

    // Fallback: map RX lens/component lines to the nearest preceding frame.
    var mappedRxFrames = mapRxComponentsToFrames(items, frameItems);
    if (mappedRxFrames.length) return mappedRxFrames;

    return [];
  }

  function extractFrameItems(items) {
    var list = Array.isArray(items) ? items : [];
    var out = [];
    var frameCount = 0;

    for (var i = 0; i < list.length; i++) {
      if (isFrameItem(list[i])) {
        out.push({
          item: list[i],
          rawIndex: i,
          orderFrameIndex: frameCount,
        });
        frameCount += 1;
      }
    }

    // If frame detection is inconclusive, treat each item as a frame-like bundle.
    if (!out.length) {
      return list.map(function (item, index) {
        return {
          item: item,
          rawIndex: index,
          orderFrameIndex: index,
        };
      });
    }

    return out;
  }

  function mapRxComponentsToFrames(items, frameItems) {
    var list = Array.isArray(items) ? items : [];
    if (!frameItems.length || !list.length) return [];

    var frameByRawIndex = {};
    frameItems.forEach(function (frameItem) {
      frameByRawIndex[frameItem.rawIndex] = frameItem;
    });

    var matchedByRawIndex = {};

    for (var i = 0; i < list.length; i++) {
      if (!isRxComponentItem(list[i])) continue;

      var targetRawIndex = -1;
      for (var j = i; j >= 0; j--) {
        if (frameByRawIndex[j]) {
          targetRawIndex = j;
          break;
        }
      }

      if (targetRawIndex !== -1) {
        matchedByRawIndex[targetRawIndex] = true;
      }
    }

    return frameItems.filter(function (frameItem) {
      return !!matchedByRawIndex[frameItem.rawIndex];
    });
  }

  function isFrameItem(item) {
    var text = getItemTextBlob(item);
    return text.indexOf("frame") !== -1;
  }

  function isRxComponentItem(item) {
    if (!item) return false;
    if (isFrameItem(item)) return false;
    return isRxFrameItem(item);
  }

  function getItemTextBlob(item) {
    return [
      item && item.name,
      item && item.title,
      item && item.variantTitle,
      item && item.variant_title,
      item && item.bundleName,
      item && item.bundle_name,
    ]
      .join(" ")
      .toLowerCase();
  }

  function isRxFrameItem(item) {
    if (!item) return false;

    if (item.isRx || item.rx || item.hasRx || item.requiresPrescription) {
      return true;
    }

    if (isRxSku(item.bundleVariantSku || item.bundle_variant_sku)) {
      return true;
    }

    var text = getItemTextBlob(item);
    if (
      text.indexOf("single vision") !== -1 ||
      text.indexOf("progressive") !== -1 ||
      text.indexOf("bifocal") !== -1 ||
      text.indexOf("prescription") !== -1
    ) {
      return true;
    }

    var skuCandidates = [];

    // Primary SKU fields on the frame/bundle object.
    skuCandidates.push(getItemSku(item));
    skuCandidates.push(item.frameSku);
    skuCandidates.push(item.frame_sku);
    skuCandidates.push(item.lensSku);
    skuCandidates.push(item.lens_sku);

    // Common nested collections where lens/component SKUs are stored.
    collectSkusFromList(item.lineItems, skuCandidates);
    collectSkusFromList(item.line_items, skuCandidates);
    collectSkusFromList(item.items, skuCandidates);
    collectSkusFromList(item.bundleItems, skuCandidates);
    collectSkusFromList(item.bundle_items, skuCandidates);
    collectSkusFromList(item.components, skuCandidates);
    collectSkusFromList(item.products, skuCandidates);

    for (var i = 0; i < skuCandidates.length; i++) {
      if (isRxSku(skuCandidates[i])) return true;
    }

    return false;
  }

  function collectSkusFromList(list, out) {
    if (!Array.isArray(list)) return;
    for (var i = 0; i < list.length; i++) {
      var entry = list[i] || {};
      out.push(entry.sku);
      out.push(entry.variantSku);
      out.push(entry.variant_sku);
      out.push(entry.bundleSku);
      out.push(entry.bundle_sku);
      out.push(entry.lensSku);
      out.push(entry.lens_sku);
      out.push(entry.frameSku);
      out.push(entry.frame_sku);
      out.push(entry.variant && entry.variant.sku);
    }
  }

  function isRxSku(sku) {
    return (
      String(sku || "")
        .toLowerCase()
        .indexOf("rx") !== -1
    );
  }

  function getItemSku(item) {
    return (
      item.bundleVariantSku ||
      item.bundle_variant_sku ||
      item.bundleSku ||
      item.bundle_sku ||
      (item.bundle && item.bundle.sku) ||
      item.sku ||
      item.variantSku ||
      item.variant_sku ||
      item.frameSku ||
      item.frame_sku ||
      (item.variant && item.variant.sku) ||
      ""
    );
  }

  // ─── Resolve "same as" chain to the root frame (personal data + file) ────────

  function resolveSourceIndex(index) {
    var visited = {};
    var current = index;
    while (!visited[current]) {
      visited[current] = true;
      var check = document.getElementById("rx-same-as-check-" + current);
      if (check && check.checked) {
        var sel = document.getElementById("rx-same-as-select-" + current);
        current = parseInt(sel.value, 10);
      } else {
        break;
      }
    }
    return current;
  }

  // ─── Toggle required state on personal fields when hidden ────────────────────

  function setPersonalRequired(personalGroup, required) {
    var inputs = personalGroup.querySelectorAll("input[data-required]");
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].required = required;
    }
  }

  // ─── Helpers: error states ────────────────────────────────────────────────────

  function showError(message) {
    loadingEl.classList.add("rx-hidden");
    errorMsgEl.textContent = message;
    errorEl.classList.remove("rx-hidden");
  }

  function showFrameError(el, message) {
    el.querySelector("p").textContent = message;
    el.classList.remove("rx-hidden");
    el.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  // ─── Helpers: form element builders ──────────────────────────────────────────

  function buildInput(opts) {
    var id = "rx-input-" + opts.index + "-" + opts.name;
    var wrapper = document.createElement("div");
    wrapper.className = "form-control";

    var input = document.createElement("input");
    input.id = id;
    input.type = opts.type || "text";
    input.name = opts.name;
    input.className = "input";
    if (opts.value) input.value = opts.value;
    if (opts.required) {
      input.required = true;
      input.dataset.required = "1";
    }
    if (opts.readonly) {
      input.readOnly = true;
      input.setAttribute("aria-readonly", "true");
    }
    if (opts.autocomplete) input.autocomplete = opts.autocomplete;
    // Floating label requires a placeholder so the :placeholder-shown trick works
    input.placeholder = opts.placeholder || " ";

    wrapper.appendChild(input);

    var label = document.createElement("label");
    label.htmlFor = id;
    label.className = "floating-label";
    label.textContent =
      opts.label + (opts.required || opts.readonly ? "" : " (optional)");
    wrapper.appendChild(label);

    return wrapper;
  }

  function buildFileInput(opts) {
    var id = "rx-file-" + opts.index + "-" + opts.name;
    var wrapper = document.createElement("div");
    wrapper.className = "form-control rx-file-control";

    var label = document.createElement("label");
    label.className = "rx-file-label";
    label.textContent = "Prescription File" + (opts.required ? " *" : "");
    wrapper.appendChild(label);

    // Hidden native input
    var input = document.createElement("input");
    input.id = id;
    input.type = "file";
    input.name = opts.name;
    input.className = "rx-file-input";
    input.accept = ".pdf,.jpg,.jpeg,.png";
    if (opts.required) input.required = true;
    wrapper.appendChild(input);

    // Row: button + filename side by side
    var row = document.createElement("div");
    row.className = "rx-file-row";

    // Styled button-like trigger label
    var trigger = document.createElement("label");
    trigger.htmlFor = id;
    trigger.className = "rx-file-trigger";
    trigger.textContent = "Choose file";
    row.appendChild(trigger);

    // Selected filename display
    var fileNameEl = document.createElement("span");
    fileNameEl.className = "rx-file-name";
    fileNameEl.textContent = "No file chosen";
    row.appendChild(fileNameEl);

    wrapper.appendChild(row);

    input.addEventListener("change", function () {
      fileNameEl.textContent = input.files[0]
        ? input.files[0].name
        : "No file chosen";
    });

    var hint = document.createElement("p");
    hint.className = "rx-field-hint text-subdued";
    hint.textContent = "Accepted formats: PDF, JPG, PNG. Max size: 10 MB.";
    wrapper.appendChild(hint);

    return wrapper;
  }

  function buildCheckbox(opts) {
    var id = "rx-checkbox-" + opts.index + "-" + opts.name;
    var wrapper = document.createElement("div");
    wrapper.className = "checkbox-control";

    var input = document.createElement("input");
    input.id = id;
    input.type = "checkbox";
    input.name = opts.name;
    input.className = "checkbox";
    input.value = "1";
    if (opts.required) input.required = true;
    wrapper.appendChild(input);

    var label = document.createElement("label");
    label.htmlFor = id;
    label.textContent = opts.label;
    wrapper.appendChild(label);

    return wrapper;
  }

  // ─── Helpers: HTML escaping ───────────────────────────────────────────────────

  function escHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function escAttr(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }
})();
